import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SCENE_IMAGE_KID, afterItems, beforeItems, differenceStats } from '../data/drum';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-67" data-mp="a5p7ycocf7a">
      <div className="mx-auto max-w-6xl" data-id="element-68" data-mp="81p7rhwc0ca">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-69" data-mp="58pb5yr9pqzn">
          <div className="lg:col-span-7" data-id="element-70" data-mp="56w62nwazetr">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-71" data-mp="3mgb0ykyw05jp">The DRUM READY™ difference</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-72" data-mp="3rh8hyu85utjm">
              From overwhelmed teacher to <em className="text-red-700" data-id="element-73" data-mp="3dj0m6pmv1ya1">calm and prepared.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-74" data-mp="3ihloculoas14">
            Imagine starting your teaching week with every lesson already organized. You know what each
            student will work on – and you have the lesson plans, materials lists, worksheets, answer keys
            and progress reports.
          </p>
        </header>

        <figure className="mt-14 overflow-hidden rounded-3xl border border-slate-900/10 shadow-xl shadow-slate-900/10" data-id="element-75" data-mp="1f8sjbrhu5nje">
          <img src={SCENE_IMAGE_KID} alt="A drum teacher in his studio showing a young student the next step of a planned lesson" loading="lazy" className="block aspect-[4/3] w-full object-cover object-top sm:aspect-[3/2]" data-id="element-76" data-mp="1t06zlqkczamr" />
        </figure>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-77" data-mp="wb7s4drlmcvm">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-78" data-mp="1abik5k4n9xid" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-79" data-mp="2lpdzasvju69l">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-80" data-mp="2gqjh9t5eolqj">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-81" data-mp="2os0m4ihs9qxx">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-82" data-mp="2otlfi4sd33u7">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-83" data-mp="2suovqsebn1vy">Before DRUM READY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-84" data-mp="2xpufplo5y6he">
              Sound familiar?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-85" data-mp="253rs02wojavs">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-86" data-mp="2a3e5mdgf6t54">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-87" data-mp="2f0nvtvbmv8u0" />
                  <span data-id="element-88" data-mp="2jsxo3i080kzg">
                    <span className="block font-semibold text-slate-900/80" data-id="element-89" data-mp="2ju8vrswsecvu">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-90" data-mp="1r9idn9i804gj">
            <p className="text-sm font-semibold text-red-300" data-id="element-91" data-mp="1et97jvyr8fd1">With DRUM READY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-92" data-mp="1ereokn71mxbl">
              Plan less. Teach more.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-93" data-mp="14vl3gff9dvi7">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-94" data-mp="10tq0l6hoja2b">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-95" data-mp="w1q6vvs7dde6">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="r46hbzq21e6x" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-97" data-mp="h7lcbee1c333">
          Focus on your students – not on making every worksheet yourself.
        </p>
      </div>
    </section>;
}